import { render, staticRenderFns } from "./CadastroToolbar.vue?vue&type=template&id=4cb51572&scoped=true&"
import script from "./CadastroToolbar.vue?vue&type=script&lang=js&"
export * from "./CadastroToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CadastroToolbar.vue?vue&type=style&index=0&id=4cb51572&prod&scoped=true&lang=css&"
import style1 from "./CadastroToolbar.vue?vue&type=style&index=1&id=4cb51572&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb51572",
  null
  
)

export default component.exports